<template>
<div id="project">
    <mProject v-show="$store.state.device == 'mob'" />
    <pProject v-show="$store.state.device == 'pc'" />
</div>
</template>

<script>
import mProject from '@/components/mProject.vue'
import pProject from '@/components/pProject.vue'
export default {
    name: 'Project',
    data (){
        return {

        }
    },
    components: {
        mProject,
        pProject,
    },
    watch: {
        $route(t){
            if(t.params && t.params.type == '4') {
                this.$router.push('/Project/1')
            }
        }
    },
    computed: {

    },
    methods: {

    },
    mounted () {
        
    }
}
</script>

<style lang="scss" scoped>

</style>
